import { Box, Flex, VStack } from '@chakra-ui/layout';
import {
  Button,
  IconButton,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  UseDisclosureProps,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';
import { ProgressBar } from './Step';

type StartYourProfileProps = {
  modalProps: UseDisclosureProps;
};

export const StartYourProfile: React.FC<StartYourProfileProps> = ({ modalProps }) => {
  const model = useSurveyBannerModel();

  return (
    <ModalContent>
      <ModalHeader
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}>
        Complete Your Profile
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="times" />}
          onClick={modalProps.onClose}
        />
      </ModalHeader>
      <ModalBody>
        <Flex flex={1} pt={'24px'} justifyContent={'space-between'} flexDirection={'column'} display={'flex'}>
          <VStack alignItems={'flex-start'} gap={'24px'} mb="100px">
            <Box w={'50%'} m={'auto'}>
              <Image image={'start-your-profile'} />
            </Box>
            <Box mt={'24px'} w={'100%'}>
              <TextBlock
                mr={'10px'}
                fontSize={'12px'}
                whiteSpace="nowrap"
                color={'blue.500'}
                weight="bold">{`Step 3 of 4`}</TextBlock>
              <TextBlock whiteSpace="nowrap" weight="bold">
                Completing your profile
              </TextBlock>
              <ProgressBar currentStep={2} totalSteps={4} />
            </Box>
            <Box>
              <TextBlock textAlign={'left'} weight="bold" fontSize={'18px'} lineHeight={'18px'}>
                Let’s get to know you better
              </TextBlock>
              <TextBlock mt={'5px'} fontSize={'14px'}>
                We’re going to ask you a couple questions about your objectives and past investment experience to help
                you set up your profile.
              </TextBlock>
            </Box>
          </VStack>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          autoFocus={true}
          isLoading={model.loading}
          isDisabled={false}
          w={'100%'}
          rightIcon={<Icon icon="chevron-right" />}
          mt={'10px'}
          onClick={() => model.nextStep()}>
          Continue
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
